import {Pipe, PipeTransform} from '@angular/core';
import {formatNumber} from '@angular/common';

@Pipe({
    name: 'shapefileValueInfo'
})
export class ShapefileValueInfoPipe implements PipeTransform {

    transform(propertyName: string, features: any[]): string {
        if (!features || features.length === 0 || !propertyName) {
            return '';
        }

        const values = features
            .map(feature => feature.properties?.[propertyName])
            .filter(value => value !== null && value !== undefined && value !== '');

        if (values.length === 0) {
            return '';
        }

        const numericValues = values.filter(v => !isNaN(Number(v))).map(v => Number(v));
        if (numericValues.length > 0 && numericValues.length === values.length) {
            const min = Math.min(...numericValues);
            const max = Math.max(...numericValues);
            const avg = numericValues.reduce((a, b) => a + b, 0) / numericValues.length;

            return ` ${formatNumber(min, 'nl', '1.0-2')}-${formatNumber(max, 'nl', '1.0-2')} ~${formatNumber(avg, 'nl', '1.0-2')}`;
        } else {
            const valueCounts = new Map<string, number>();
            values.forEach(v => {
                const str = String(v);
                valueCounts.set(str, (valueCounts.get(str) || 0) + 1);
            });

            const sortedValues = Array.from(valueCounts.entries()).sort((a, b) => b[1] - a[1]);
            const displayValues = sortedValues.slice(0, 5).map(([val, count]) => `${val} (${count})`);
            const result = displayValues.join(', ');

            if (sortedValues.length > 5) {
                return ` ${result}... +${sortedValues.length - 5} meer`;
            }

            return ` ${result}`;
        }
    }
}
